import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import * as api from '../services/api';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [projectInfo, setProjectInfo] = useState(null);
  const [about, setAbout] = useState(null);
  const [partners, setPartners] = useState([]);
  const [activities, setActivities] = useState([]);
  const [resources, setResources] = useState([]);
  const [dissemination, setDissemination] = useState(null);
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAllData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [projectData, aboutData, partnersData, activitiesData, resourcesData, disseminationData, contactData] = await Promise.all([
        api.getProjectInfo(),
        api.getAbout(),
        api.getPartners(),
        api.getActivities(),
        api.getResources(),
        api.getDissemination(),
        api.getContact()
      ]);
      
      setProjectInfo(projectData);
      setAbout(aboutData);
      setPartners(partnersData);
      setActivities(activitiesData);
      setResources(resourcesData);
      setDissemination(disseminationData);
      setContact(contactData);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  const value = {
    projectInfo,
    about,
    partners,
    activities,
    resources,
    dissemination,
    contact,
    loading,
    error,
    refetch: fetchAllData
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};
